import { Injectable, Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { Router } from '@angular/router';
import { IMfeService } from '@mynexus/mfe-core';

const map = {
  "mnc-dmepos-auth-request-initial": () => import("../../feature/auth-request-initial/auth-request-initial.component"),
  "mnc-dmepos-authorization-details": () => import("../../feature/authorization-details/authorization-details.component"),
  "mnc-dmepos-authorizations-summary": () => import("../../feature/authorizations-summary/authorizations-summary.component"),
  "mnc-dmepos-member-ribbon": () => import("../../shared/components/member-ribbon/member-ribbon.component"),
  "mnc-dmepos-provider-dashboard": () => import("../../feature/provider-dashboard/provider-dashboard.component"),
  "mnc-dmepos-queue": () => import("../../feature/queue/queue.component"),
}

@Injectable({
  providedIn: 'root'
})
export class DmeposMfeService implements IMfeService {
  donePromise: Promise<boolean>;
  resolve: (value: boolean) => void;

  constructor(
    private router: Router,
    private injector: Injector
  ) {
    this.donePromise = new Promise<boolean>((resolve) => {
      this.resolve = resolve;
    })
   }

  navigate(path: string): void {
    this.router.navigate([path]);
  }

  loadComponent(name: string): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        if(map[name]){
          map[name]().then(module => {
            customElements.define(
              name,
              createCustomElement<void>(module[Object.keys(module)[0]], { injector: this.injector })
            );
            resolve();
          });
        }else {
          reject('component not found');
        }
      }
      catch (error) {
        reject(error);
      }
    });
  }
}
